@if (currentStep$ | async; as step) {
  <lib-step-supplier
    [sessionId]="sessionId()"
    [isFetching]="(isFetching$ | async)!"
    [step]="step"
  />
} @else {
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
}
